import { Component } from '@angular/core';

@Component({
    selector: 'app-employee-edit',
    templateUrl: './employee-edit.component.html',
    styleUrls: ['./employee-edit.component.css'],
    standalone: false
})
export class EmployeeEditComponent {
  roles: any = [
		"admin",
		"employee"
	];
  hide = true;
}
